import React, { useCallback } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { FeaturesStrip } from './components/FeaturesStrip';
import { ProductsSection } from './components/ProductsSection';
import { CartSidebar } from './components/CartSidebar';
import { Footer } from './components/Footer';
import { Toast } from './components/Toast';
import { useCart } from './hooks/useCart';
import type { Product } from './data/products';
export function App() {
  const {
    cart,
    addToCart,
    removeItem,
    changeQty,
    totalItems,
    totalPrice,
    isOpen,
    toggleCart,
    closeCart,
    openCart,
    toastVisible,
    showToast
  } = useCart();
  const handleAddToCart = useCallback((product: Product) => {
    addToCart(product);
    showToast();
    openCart();
  }, [addToCart, showToast, openCart]);
  return <div className="min-h-screen w-full bg-[#f9f9f9]" data-id="element-0">
      <Navbar cartCount={totalItems} onCartClick={toggleCart} data-id="element-1" />
      <HeroSection data-id="element-2" />
      <FeaturesStrip data-id="element-3" />
      <ProductsSection onAddToCart={handleAddToCart} data-id="element-4" />
      <Footer data-id="element-5" />
      <CartSidebar isOpen={isOpen} cart={cart} totalPrice={totalPrice} onClose={closeCart} onRemoveItem={removeItem} onChangeQty={changeQty} data-id="element-6" />
      <Toast visible={toastVisible} data-id="element-7" />
    </div>;
}